import { deleteWireDisbursementAsync } from 'API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: deleteWireDisbursementSlice, asyncAction: deleteWireDisbursementAction } = createAsyncSlice(
  'deleteWireDisbursementSlice',
  deleteWireDisbursementAsync
);
